import { Show } from "@refinedev/antd";
import { useShow } from "@refinedev/core";
import { Descriptions, Image, Space, Tag, Typography } from "antd";

import { formatCoordinates, formatYear, statusMeta } from "../../lib/constants";

export function PhotoShow() {
  const { query, result } = useShow({ resource: "photos" });
  const record = result as
    | {
        id: string;
        imageUrl?: string;
        objectKey?: string;
        location?: { latitude?: number; longitude?: number };
        year?: number;
        yearTo?: number;
        description?: string;
        sourceUrl?: string;
        status?: string;
        moderationComment?: string;
        createdBy?: { username?: string };
        createdAt?: string;
      }
    | undefined;

  const meta = statusMeta(record?.status);

  return (
    <Show isLoading={query.isLoading} title="Фотография">
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        {record?.imageUrl && (
          <Image src={record.imageUrl} style={{ maxHeight: 420, objectFit: "contain" }} />
        )}

        <Descriptions bordered column={2} size="small">
          <Descriptions.Item label="Описание" span={2}>
            {record?.description || <Typography.Text type="secondary">—</Typography.Text>}
          </Descriptions.Item>

          <Descriptions.Item label={record?.yearTo && record.yearTo > (record.year ?? 0) ? "Период" : "Год"}>
            {record?.yearTo && record.yearTo > (record.year ?? 0)
              ? `${formatYear(record.year)} — ${formatYear(record.yearTo)}`
              : formatYear(record?.year)}
          </Descriptions.Item>

          <Descriptions.Item label="Координаты">
            {formatCoordinates(record?.location?.latitude, record?.location?.longitude)}
          </Descriptions.Item>

          <Descriptions.Item label="Статус">
            {meta ? <Tag color={meta.color}>{meta.label}</Tag> : "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Автор">
            {record?.createdBy?.username ?? "—"}
          </Descriptions.Item>

          <Descriptions.Item label="Источник" span={2}>
            {record?.sourceUrl ? (
              <Typography.Link href={record.sourceUrl} target="_blank">
                {record.sourceUrl}
              </Typography.Link>
            ) : (
              <Typography.Text type="warning">не указан</Typography.Text>
            )}
          </Descriptions.Item>

          {record?.moderationComment && (
            <Descriptions.Item label="Комментарий модератора" span={2}>
              {record.moderationComment}
            </Descriptions.Item>
          )}

          <Descriptions.Item label="Ключ объекта" span={2}>
            <Typography.Text code copyable>
              {record?.objectKey}
            </Typography.Text>
          </Descriptions.Item>
        </Descriptions>
      </Space>
    </Show>
  );
}
